<p-button
  userCta
  [loading]="waitingForWishlistResponse"
  styleClass="p-button-rounded"
  class="add-to-wishlist"
  [pTooltip]="wishlistHint"
  [tooltipOptions]="hintOptions"
  [ngClass]="{ active: isMovieInMyWishList(movie) }"
  (authorizedClick)="onAddMovieToWishlist()"
>
  <ng-template pTemplate="icon">
    <fa-icon [icon]="bookmarkIcon" [size]="'lg'" />
  </ng-template>
</p-button>
<p-button
  userCta
  class="watch-movie"
  [loading]="waitingForWatchedMovieResponse"
  [pTooltip]="watchedHint"
  [tooltipOptions]="hintOptions"
  styleClass="p-button-rounded"
  [ngClass]="{ active: movie.inMyWatched }"
  (authorizedClick)="onMarkMovieAsWatched()"
>
  <ng-template pTemplate="icon">
    <fa-icon [icon]="watchedIcon" [size]="'lg'" />
  </ng-template>
</p-button>
<p-button
  *ngIf="ratingEnabled"
  userCta
  class="rate-movie"
  [pTooltip]="rateHint"
  [tooltipOptions]="hintOptions"
  styleClass="p-button-rounded"
  [ngClass]="{ active: movie.myRank }"
  (authorizedClick)="onRateMovie()"
>
  <ng-template pTemplate="icon">
    <fa-icon [icon]="hearthIcon" [size]="'lg'" />
  </ng-template>
</p-button>
<p-button
  userCta
  class="add-to-list"
  styleClass="p-button-rounded"
  [pTooltip]="addToListHint"
  [tooltipOptions]="hintOptions"
  (authorizedClick)="addMovieToList($event)"
>
  <ng-template pTemplate="icon">
    <fa-icon [icon]="listIcon" [size]="'lg'" />
  </ng-template>
</p-button>
<p-button
  class="share-movie"
  styleClass="p-button-rounded"
  [pTooltip]="shareHint"
  [tooltipOptions]="hintOptions"
  (onClick)="onSharing()"
>
  <ng-template pTemplate="icon">
    <fa-icon [icon]="shareIcon" [size]="'lg'" />
  </ng-template>
</p-button>
